module.exports = __webpack_public_path__ + "img/logo.7de20dbb.png";